+function ($) {
    'use strict';

}(jQuery);
